import React from 'react';

interface SolidFrameProps {
  children: React.ReactNode;
  className?: string;
  backgroundColor?: string;
  borderRadius?: number;
}

export const SolidFrame: React.FC<SolidFrameProps> = ({
  children,
  className = '',
  backgroundColor,
  borderRadius = 8
}) => {
  return (
    <div
      className={`solid-frame overflow-hidden h-full flex items-center justify-center ${className}`}
      style={{
        backgroundColor: backgroundColor || '#FFFFFF',
        borderRadius: `${borderRadius}px`,
        isolation: 'isolate'
      }}
    >
      {children}
    </div>
  );
};
